/* tslint:disable */
/* eslint-disable */
/**
 * TOM INTEGRATION API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerTurnoverInternalQueryResult } from '../model';
// @ts-ignore
import type { ContainerTurnoverQueryResult } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
/**
 * ContainerTurnoverApi - axios parameter creator
 */
export const ContainerTurnoverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiContainerTurnoverByContainerIdGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integration/api/ContainerTurnover/ByContainerId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiContainerTurnoverByIdGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integration/api/ContainerTurnover/ById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [containerId] 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiInternalContainerTurnoverGet: async (containerId?: number, tenantId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integration/api/internal/ContainerTurnover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (containerId !== undefined) {
                localVarQueryParameter['containerId'] = containerId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerTurnoverApi - functional programming interface
 */
export const ContainerTurnoverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerTurnoverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationApiContainerTurnoverByContainerIdGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverQueryResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationApiContainerTurnoverByContainerIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoverApi.integrationApiContainerTurnoverByContainerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationApiContainerTurnoverByIdGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerTurnoverQueryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationApiContainerTurnoverByIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoverApi.integrationApiContainerTurnoverByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [containerId] 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationApiInternalContainerTurnoverGet(containerId?: number, tenantId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverInternalQueryResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationApiInternalContainerTurnoverGet(containerId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoverApi.integrationApiInternalContainerTurnoverGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerTurnoverApi - factory interface
 */
export const ContainerTurnoverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerTurnoverApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiContainerTurnoverByContainerIdGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverQueryResult>> {
            return localVarFp.integrationApiContainerTurnoverByContainerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiContainerTurnoverByIdGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerTurnoverQueryResult> {
            return localVarFp.integrationApiContainerTurnoverByIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [containerId] 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiInternalContainerTurnoverGet(containerId?: number, tenantId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverInternalQueryResult>> {
            return localVarFp.integrationApiInternalContainerTurnoverGet(containerId, tenantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainerTurnoverApi - object-oriented interface
 */
export class ContainerTurnoverApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public integrationApiContainerTurnoverByContainerIdGet(id?: string, options?: RawAxiosRequestConfig) {
        return ContainerTurnoverApiFp(this.configuration).integrationApiContainerTurnoverByContainerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public integrationApiContainerTurnoverByIdGet(id?: string, options?: RawAxiosRequestConfig) {
        return ContainerTurnoverApiFp(this.configuration).integrationApiContainerTurnoverByIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [containerId] 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public integrationApiInternalContainerTurnoverGet(containerId?: number, tenantId?: number, options?: RawAxiosRequestConfig) {
        return ContainerTurnoverApiFp(this.configuration).integrationApiInternalContainerTurnoverGet(containerId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}

